(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Article-section"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Toggle "Read More" visibility
    document.querySelectorAll('.read_btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const container = this.closest('.pro_desc-main');
        container.querySelector('.des_half').style.display = 'none';
        container.querySelector('.des_full').style.display = 'block';
      });
    });

    // Toggle "Read Less" visibility
    document.querySelectorAll('.read_less').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const container = this.closest('.pro_desc-main');
        container.querySelector('.des_half').style.display = 'block';
        container.querySelector('.des_full').style.display = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
